module.exports = __webpack_public_path__ + "static/media/t2.1010697c.svg";